export default __webpack_public_path__ + "static/media/la-fonte.f08ed3a2.png";